import {formatFieldAsText, strip} from '@/common/questionsExporter/utility'

const labelingQuestion = (question) => {
    const labels = question.labels ? question.labels : []
    const formattedLabels = labels.map(formatFieldAsText).join("\n")

    const incorrectClues = question.incorrect_clues ? question.incorrect_clues : []
    const formattedClues = incorrectClues.map(formatFieldAsText).join("\n")

    const strippedPrompt = strip(question.question)

    return `${strippedPrompt}\nLabels:\n${formattedLabels}\nIncorrect Clues:\n${formattedClues}`
}

export {labelingQuestion}
